import { render, staticRenderFns } from "./MySetting.vue?vue&type=template&id=3963acdc&"
import script from "./MySetting.vue?vue&type=script&lang=js&"
export * from "./MySetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports